export interface FrontPresenterCuration {
    authorId: number;
    role: string;
}

// Author.Id is the stable join key. Display names and portraits remain owned by
// the public authors API, while homepage-specific role copy stays curated here.
export const frontPresenterCuration: FrontPresenterCuration[] = [
    {
        authorId: 16,
        role: "Presenter \u00b7 Writer",
    },
    {
        authorId: 18,
        role: "Filmmaker \u00b7 Journalist",
    },
    {
        authorId: 19,
        role: "Director \u00b7 Presenter",
    },
];
